import { useEffect, useState } from 'react';
import { DEFAULT_SETTINGS } from '@harmony/shared';
import { api } from './api';

type Settings = Record<string, unknown>;
let cache: Settings | null = null;
let loading: Promise<Settings> | null = null;

/** Public feature switches from the admin, loaded once per app open. Defaults until loaded. */
export function useSettings(): Settings {
  const [s, setS] = useState<Settings>(cache ?? (DEFAULT_SETTINGS as Settings));
  useEffect(() => {
    if (cache) return;
    loading ??= api.publicSettings().then((r) => (cache = { ...DEFAULT_SETTINGS, ...r }));
    loading.then(setS).catch(() => undefined);
  }, []);
  return s;
}

export const isOn = (s: Settings, key: string) => s[key] === true;
